'use strict';

var fragt = fragt || {};

fragt.quoteSection = fragt.quoteSection || new function () {

    this.init = function () {
        var quoteInner = document.querySelector('.quote-section__inner');
        var quoteBackground = document.querySelector('.quote-section__background');

        if (quoteInner != null) {
            if (quoteInner.children.length < 2) {
                quoteBackground.classList.add('quote-section__background--only-one');
                quoteInner.classList.add('quote-section__inner--only-one');
            }
        }
    };
}(); 
